// extracted by mini-css-extract-plugin
module.exports = {"Inf_move_or_copy_modal":"Inf_move_or_copy_modal--XkweX","forPadding":"forPadding--3ruRl"};